<template>
  <div class="kbo kbo-highlight-list">
    <div class="page-top">
      <div class="page-top-inner-wrap">
        <h2 tabindex="0" class="page-title">프로야구</h2>
      </div>
    </div>
    <h3 class="kbo-list-title">경기별 하이라이트</h3>
    <div v-if="currentDate !== null">
      <year-month-selector :current-date="currentDate" :change-fn="setNewDate"></year-month-selector>
      <schedule-date-slider :current-date="currentDate" :change-fn="setNewDate"></schedule-date-slider>
      <highlight-wrapper :current-date="currentDate" :change-fn="setNewTeamCode"></highlight-wrapper>
    </div>
  </div>
</template>
<script>
  import _ from 'lodash'
  import KboDate from '@/common/model/KboDate'
  import ScheduleDateSlider from '@/components/kbo/ScheduleDateSlider'
  import YearMonthSelector from '@/components/kbo/YearMonthSelector'
  import HighlightWrapper from '@/components/kbo/HighlightWrapper'
  import { parseUrl } from 'query-string'
  export default {
    name: 'HighLightController',
    components: {
      YearMonthSelector,
      ScheduleDateSlider,
      HighlightWrapper
    },
    data () {
      return {
        currentDate: null,
        query: {}
      }
    },
    methods: {
      setNewDate (kboDate) {
        this.currentDate = kboDate
        this.query = Object.assign({}, this.query, { date: kboDate.getYearMonthDate() })
        this.applyNewQuery()
      },
      setNewTeamCode (teamCode) {
        this.query = Object.assign({}, this.query, { team: teamCode })
        this.applyNewQuery()
      },
      applyNewQuery () {
        try {
          this.$router.replace({
            path: this.$route.path,
            query: this.query
          })
        } catch (e) {}
      },
      setCurrentDate () {
        const queryDate = _.get(this.$route, ['query', 'date'], '')
        try {
          const currentDate = new KboDate()
          if (queryDate !== '') {
            currentDate.setQueryDate(queryDate)
          }
          this.currentDate = currentDate
        } catch (e) {
          this.currentDate = new KboDate()
        }
        this.query = Object.assign({}, this.query, { date: this.currentDate.getYearMonthDate() })
      }
    },
    created () {
      const { query } = parseUrl(location.href)
      this.query = query
      this.setCurrentDate()
    },
    watch: {
      $route (newRoute, oldRoute) {
        const newDate = _.get(newRoute, 'query.date', '')
        const oldDate = _.get(oldRoute, 'query.date', '')
        if (newDate !== oldDate) {
          this.setCurrentDate()
        }
      }
    }
  }
</script>
<style lang="css" src="@/assets/css/common.css"></style>
<style lang="css" src="@/assets/css/base.css"></style>
<style lang="css" src="@/assets/css/kbo.css"></style>
